import React from 'react';
import styled from 'styled-components';

const MenuTitleWrapper = styled.span`
  font-size: 12px;
  margin: 40px 16px 0;
`;

function MenuTitle() {
  return <MenuTitleWrapper>Seja bem-vindo(a) :)</MenuTitleWrapper>;
}

export default MenuTitle;
